const PlayerPositionStacking = {
    PLAYER_POSITION_STACKING_SET_DATA_FROM_STORAGE: 'PLAYER_POSITION_STACKING_SET_DATA_FROM_STORAGE',
    PLAYER_POSITION_STACKING_SET_IS_USED: 'PLAYER_POSITION_STACKING_SET_IS_USED',
    PLAYER_POSITION_STACKING_ADD_ITEM: 'PLAYER_POSITION_STACKING_ADD_ITEM',
    PLAYER_POSITION_STACKING_REMOVE_ITEM: 'PLAYER_POSITION_STACKING_REMOVE_ITEM',
    PLAYER_POSITION_STACKING_KEY_PLAYER_POINTS: 1000,
    PLAYER_POSITION_STACKING_MIN_KEY_PLAYERS_TO_INCREASE_POINTS: 2,
    PLAYER_POSITION_STACKING_SET_SECONDARY_STACK_IS_USED: 'PLAYER_POSITION_STACKING_SET_SECONDARY_STACK_IS_USED',
    PLAYER_POSITION_STACKING_SET_SECONDARY_STACK_IS_FORCED: 'PLAYER_POSITION_STACKING_SET_SECONDARY_STACK_IS_FORCED',
    PLAYER_POSITION_STACKING_SET_ALLOW_OVERLAP_PRIMARY_AND_SECONDARY_STACKS:
        'PLAYER_POSITION_STACKING_SET_ALLOW_OVERLAP_PRIMARY_AND_SECONDARY_STACKS',
    PLAYER_POSITION_STACKING_SET_SECONDARY_STACK_COMBINATION_TYPE:
        'PLAYER_POSITION_STACKING_SET_SECONDARY_STACK_COMBINATION_TYPE',
};

export default PlayerPositionStacking;
